import request from 'tools/request'

const apiUrl = `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/radius-operation/`

const updateExportSettings = async (
  carrierIds: (string | number)[],
  radius1: number,
  radius2: number,
  radius3: number,
  radius4: number,
  useKilometers?: boolean
) => {
  const res = await request.put(
    `${apiUrl}export-settings`,
    { carrierIds: carrierIds.map(Number), radius1, radius2, radius3, radius4 },
    { params: { ...(useKilometers !== undefined && { useKilometers }) } }
  )
  return res.data
}

const deleteExportSettings = async (carrierIds: (string | number)[]) => {
  const res = await request.put(
    `${apiUrl}export-settings/delete`,
    carrierIds.map(Number)
  )
  return res.data
}

const getAllExportSettings = async (useKilometers?: boolean) => {
  const res = await request.get(`${apiUrl}export-settings/all`, {
    params: { ...(useKilometers !== undefined && { useKilometers }) },
  })
  return res.data
}

export { updateExportSettings, deleteExportSettings, getAllExportSettings }
